import styled from 'styled-components'

export const Container = styled.div`
  background-color: #F6F6FA;
  box-shadow: 0px 10px 20px 0px #00000040;
  border-radius: 24px;
  padding: 32px 24px;
  height: 80vh;
  max-width: 668px;
  width: calc(100vw - 64px);
`

export const Article = styled.article`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  overflow-y: auto;

  & > header,
  & > footer {
    display: flex;
    flex-direction: column;
    gap: 8px;

    & > h1 {
      font-size: 1.5rem;
      font-style: italic;
      text-align: center;
    }

    & > h2 {
      font-size: 1.25rem;
      font-style: italic;
      text-align: center;
    }
  }

  ol {
    list-style: none;
    padding-block: 0.5em;

    li {
      margin-bottom: 0.5em;
      text-align: justify;

      & > .item-header {
        background-color: #013C1A;
        color: #FFF;
        font-size: 1.125rem;
        margin-bottom: 0.5em;
        padding-block: 4px;
        text-align: center;
      }

      & > ol > li > ol > li {
        padding-left: 1em;
      }

      & > img {
        display: block;
        margin: 1em auto;
      }
    }
  }

  & > section {
    & > h3 {
      background-color: #013C1A;
      color: #FFF;
      font-size: 1.125rem;
      margin-bottom: 0.5em;
      padding-block: 4px;
      text-align: center;
    }

    & > p {
      font-size: 1rem;
      text-align: justify;
    }
  }

  & > footer {
    text-align: justify;

    & > h3 {
      font-size: 1.25rem;
    }
  }
`
